<template lang="pug">
  #team-builder-controls.buttons
    WtButton.back(
      is-text
      color="lightgrey"
      bold
      @click.native.prevent="showCancel ? cancel() : previous.action()"
    ) {{ showCancel ? 'CANCEL' : 'BACK' }}
    //- allow user to navigate to next step or submit form if it is last step
    WtButton.next(
      :color="disableNext ? 'lightgrey' : 'primary'"
      bold
      size="large"
      :disabled="disableNext"
      :loading="submitting"
      @click.native.prevent="triggerAction"
    ) {{ nextButtonText }}
</template>

<script>
import WtButton from "@@/WtButton/WtButton";

export default {
  name: "TeamBuilderControls",

  components: { WtButton },

  props: {
    previous: {
      type: Object,
      required: true
    },

    next: {
      type: Object,
      required: true
    },

    disableNext: {
      type: Boolean,
      default: true
    },

    showCancel: {
      type: Boolean,
      default: false
    },

    /**
     * enables submit button for team creation
     */
    lastStep: {
      type: Boolean,
      default: false
    },

    registrationBuilder: {
      type: Boolean,
      default: false
    },

    dismissModal: {
      type: Function,
      default: () => {}
    }
  },

  data() {
    return {
      submitting: false
    };
  },

  computed: {
    nextButtonText() {
      return this.lastStep ? "SUBMIT" : "NEXT";
    },

    isAdminSuperComponent() {
      return this.$route.name === "AdminSuperTeamCenterBuilder";
    },

    isAdminBuilder() {
      return /admin/.test(this.$route.path);
    }
  },

  methods: {
    triggerAction() {
      if (this.lastStep && !this.submitting) {
        this.submitting = true;
        this.$emit("submit");
      } else {
        this.next.action();
      }
    },

    cancel() {
      if (this.registrationBuilder) {
        this.dismissModal();
        return;
      }
      let name = "Teams";

      if (this.isAdminBuilder) {
        name = this.isAdminSuperComponent
          ? "AdminSuperTeamCenterSettings"
          : "TeamCenterSettings";
      }

      return this.$router.push({ name });
    }
  }
};
</script>

<style lang="sass">
#team-builder-controls
  position: absolute
  bottom: 4rem
  left: 4rem
</style>
